import { CapacitorException, ExceptionCode, WebPlugin } from '@capacitor/core';
export class NavigationBarWeb extends WebPlugin {
    async getColor() {
        throw this.createUnimplementedError();
    }
    async getStyle() {
        throw this.createUnimplementedError();
    }
    async hide() {
        throw this.createUnimplementedError();
    }
    async setColor(_options) {
        throw this.createUnimplementedError();
    }
    async setStyle(_options) {
        throw this.createUnimplementedError();
    }
    async show() {
        throw this.createUnimplementedError();
    }
    createUnimplementedError() {
        return new CapacitorException('This plugin method is not implemented on this platform.', ExceptionCode.Unimplemented);
    }
}
//# sourceMappingURL=web.js.map